import styled from 'styled-components';

interface ItemProps {
  readonly type?: string;
}
export const CardWrapper = styled.div`
  box-sizing: border-box;
  height: 145px;
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
`;
export const CardHeader = styled.div`
  height: 53px;
  border-radius: 4px 4px 0 0;
  background-color: rgba(235, 237, 242, 1);
  display: flex;
`;
export const CardNumber = styled.input`
  color: rgba(61, 61, 61, 1);
  font-family: 'Proxima Nova';
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  margin: 19px 0px 13px 5px;
  border: none;
  color: #3d3d3d;
  font-family: 'Proxima Nova';
`;
export const CardNumberHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 26px 0 23px;
`;
export const CardIconNumber = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 8px;
  }
`;
export const CardExpiry = styled.div`
  color: rgba(74, 74, 74, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  letter-spacing: 0;
  line-height: 17px;
  color: rgba(74, 74, 74, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  letter-spacing: 0;
  line-height: 17px;
  margin: 19px 9px 17px auto;
`;
export const CardDataContainer = styled.div`
  padding: 23px 0 29px 26px;
`;
export const CardHolder = styled.div`
  color: rgba(61, 61, 61, 0.5);
  font-family: 'Proxima Nova';
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
  margin-bottom: 4px;
`;
export const CardHolderName = styled.div`
  color: rgba(45, 45, 45, 1);
  font-family: 'Proxima Nova';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 21px;
`;
export const CardOptionsContainer = styled.div`
  height: 32px;
  display: flex;
  justify-content: flex-end;
`;
export const CardContainer = styled.div`
  height: 177px;
  width: 499px;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 0.5px solid rgba(182, 192, 195, 0.51);
`;
export const RemoveLabel = styled.div<ItemProps>`
  color: ${props => (props.type === 'remove' ? 'rgba(245, 75, 35, 1)' : ' rgba(0,122,255,1)')};
  font-family: 'Proxima Nova';
  font-size: 15px;
  letter-spacing: 0;
  line-height: 14px;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
  margin: ${props => (props.type === 'remove' ? '12px 18px 5px 0px' : ' 12px 4px 5px 0px')};
`;
export const RadiosContainer = styled.div`
  margin: 8px auto 0px 0px;
`;
